import { render, staticRenderFns } from "./UndoButton.vue?vue&type=template&id=5e577192&"
import script from "./UndoButton.vue?vue&type=script&lang=js&"
export * from "./UndoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports